var _circle, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20,
    stroke: "#fff",
    strokeOpacity: 0.4,
    strokeWidth: 1.83
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.188 25v-7H16.5l5.5-5.5v18L16.5 25h-4.313zM25 19l6 6M25 25l6-6"
  }))));
}

export default SvgMute;